import { render, staticRenderFns } from "./EditFollowUpRecord.vue?vue&type=template&id=edf4819e&scoped=true&"
import script from "./EditFollowUpRecord.vue?vue&type=script&lang=js&"
export * from "./EditFollowUpRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf4819e",
  null
  
)

export default component.exports